import { render } from "./psychologicForm.vue?vue&type=template&id=5caf251a&scoped=true"
import script from "./psychologicForm.vue?vue&type=script&lang=js"
export * from "./psychologicForm.vue?vue&type=script&lang=js"

import "./psychologicForm.vue?vue&type=style&index=0&id=5caf251a&scoped=true&lang=css"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5caf251a"]])

export default __exports__